"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _excluded = ["classes", "className", "theme", "innerRef"];
/*:: // 

import { type Ref } from 'react';*/
/*:: import { type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var Style = function Style() {
  return {
    root: {}
  };
};
/*:: type Props = InjectSheetProvidedProps &
  HTMLElement & {
    innerRef?: Ref<*>
  };*/
var ListView = function ListView(_ref /*:: */) {
  var classes = _ref /*:: */.classes,
    className = _ref /*:: */.className,
    theme = _ref /*:: */.theme,
    innerRef = _ref /*:: */.innerRef,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: className
  }, props, {
    ref: innerRef
  }));
};
ListView.displayName = 'ListView';
var _default = exports.default = (0, _injectSheet.default)(Style)(ListView);
//# sourceMappingURL=ListView.js.map